export default __webpack_public_path__ + "static/stats_3-fc17ab0baae4386b34e13c57f5150f81.png";